module.exports = __webpack_public_path__ + "img/icons-general-money.360018c9.svg";